import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as NotificationsContext} from '../../contexts/Notifications'

import DropZone from '../../components/Dropzone';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

const failedDownloadSnack = "PlatformCostCalculations-failedDownloadSnack"

const PlatformCostCalculations = ({open, close, model,  ...rest}) => {
  
  const app = React.useContext(AppContext)
  const { vendor } = app
  const { upsert } = app.platformcostcalculations
  const {createSnack, openSnack, deleteSnack} = React.useContext(NotificationsContext)
  const [disabled, setDisabled] = React.useState(false)
  const [filesAmazon, setAmazonFiles] = React.useState([])
	const [filesMercado, setMercadoFiles] = React.useState([])
	const [clear, setClear] = React.useState(false)
	React.useEffect(() => {
		setClear(true)
	}, [vendor])

	React.useEffect(() => {
		clear && setClear(false)
	}, [clear])
  const flag = filesAmazon.length > 0 || filesMercado.length > 0

  React.useEffect(() => {
		createSnack(failedDownloadSnack, {message: "Falló la generación de liquidaciones"})
		return () => deleteSnack(failedDownloadSnack)
	}, [])

  const onError = () => {
    console.log({clear, disabled})
		setDisabled(false)
		openSnack(failedDownloadSnack)
	}

  const onSuccess = () => {
    setDisabled(false)
    //setClear(true)
  }

  const submit = (e) => {
		e.stopPropagation()
		setDisabled( true)

		const data = new FormData()
		data.append("vendor", vendor)
		data.append("platformCostCalculations", vendor === 'amazon'? filesAmazon[0] : filesMercado[0])
		upsert(data, onSuccess, onError)
  }

  return (
    <Paper sx={{padding:"15px"}}>
      <h3>Añadir costos y dimensiones de Plataforma</h3> <br />
      {!vendor && <h4>Selecciona un canal de venta</h4>}
      <Box sx={{display:vendor === 'amazon'?'block':'none'}}>
        <DropZone accept=".csv" setFiles={setAmazonFiles} clear={clear} />
      </Box>
      
      <Box sx={{display:vendor === 'mercado'?'block':'none'}}>
        <DropZone accept=".xlsx" setFiles={setMercadoFiles} clear={clear} />
      </Box>
      
      <Button disabled={disabled || !flag || !vendor} onClick={submit}>Enviar</Button>
    </Paper>
  )
}
export default PlatformCostCalculations